import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { ApiService } from './api.service';
import { DashNotificationsService } from './dash-notifications.service';

export interface ListingInquiry {
  timelineId: number,
  question: string,
  emailAddress: string,
}

@Injectable({
  providedIn: 'root'
})
export class ListingInquryService {

  constructor(
    private apiService: ApiService,
    private notifications: DashNotificationsService
  ) { }

  submit(listingInquiry: ListingInquiry) {
    return this.apiService.post('inquiry', this.inquiryParams(listingInquiry)).pipe(
      tap(
        () => {
          this.notifications.success('Inquiry Received. Someone Will Contact You Shortly.');

        },
        (error: any) => {
          this.notifications.error('An unexpected error occurred. Reach out to success@newfoundgroup.com for help!');
        }
      ))

  }

  private inquiryParams(listingInquiry: ListingInquiry) {
    return {
      timeline_id: listingInquiry.timelineId,
      email_address_of_lead: listingInquiry.emailAddress.trim(),
      inquiry_question: listingInquiry.question?.trim()
    }
  }
}
